import { QFlex } from '@qualio/ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChangeRequest } from '../../../../api/model/changeRequestItem';
import {
  ChangeRequestStatus,
  ChangeRequestStatusEnum,
} from './ChangeRequestStatus/ChangeRequestStatus';
import { DisplayTimestamp } from './DisplayTimestamp/DisplayTimestamp';
import { DotSeparator } from './DotSeparator/DotSeparator';
import { Owner } from './Owner/Owner';

type ChangeRequestSideDrawerHeaderInfoRowProps = {
  changeRequest: ChangeRequest;
};

export const ChangeRequestSideDrawerHeaderInfoRow: React.FC<
  ChangeRequestSideDrawerHeaderInfoRowProps
> = ({ changeRequest }) => {
  const { t } = useTranslation();
  return (
    <QFlex
      flexDirection="row"
      alignItems="center"
      data-cy={'change-request-side-drawer-details-metadata'}
    >
      <ChangeRequestStatus status={changeRequest.status} />
      <DotSeparator />
      <Owner
        id={changeRequest.owner.id}
        fullName={changeRequest.owner.full_name}
      />
      <DotSeparator />
      {changeRequest.status === ChangeRequestStatusEnum.CLOSED &&
      changeRequest.closed_at ? (
        <DisplayTimestamp
          type={t('timestamps.dateClosed')}
          date={changeRequest.closed_at}
        />
      ) : (
        <>
          <DisplayTimestamp
            type={t('timestamps.dateCreated')}
            date={changeRequest.created_at}
          />
          {changeRequest.last_modified_at ? (
            <>
              <DotSeparator />
              <DisplayTimestamp
                type={t('timestamps.modified')}
                date={changeRequest.last_modified_at}
              />
            </>
          ) : null}
        </>
      )}
    </QFlex>
  );
};
